import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Database, Pencil, Trash } from "lucide-react";
import type { Dataset } from "@/types/dataset";

interface DatasetListProps {
  datasets: Dataset[] | undefined;
  onSelectDataset: (dataset: Dataset) => void;
  onDeleteDataset: (id: string) => void;
  onEditDataset: (dataset: Dataset) => void;
}

export const DatasetList = ({ datasets, onSelectDataset, onDeleteDataset, onEditDataset }: DatasetListProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Description</TableHead>
          <TableHead className="w-[150px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {datasets?.map((dataset) => (
          <TableRow key={dataset.id}>
            <TableCell>{dataset.name}</TableCell>
            <TableCell>{dataset.description}</TableCell>
            <TableCell>
              <div className="flex gap-2">
                <Button variant="outline" size="icon" onClick={() => onSelectDataset(dataset)}>
                  <Database className="h-4 w-4" />
                </Button>
                <Button variant="outline" size="icon" onClick={() => onEditDataset(dataset)}>
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button variant="destructive" size="icon" onClick={() => onDeleteDataset(dataset.id)}>
                  <Trash className="h-4 w-4" />
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
